import { environmentaldatas } from "../../../../../../constant/defaultValues";
import { getRequest, postRequest, deleteRequest } from "../../../../../../hooks/axiosClient";
import { convertToObject, ensureArray, safeJsonParse } from "../../../utils/pinServices";

const { image_url } = environmentaldatas;

export const saveProduct = async (payload) => {
    const response = await postRequest('product', payload);
    return response;
};

export const movePinToGroupApi = async (payload) => {
    const response = await postRequest('product', payload);
    return response;
};

export const dropToGroupApi = async (product_id, group_id) => {
    const response = await postRequest('product/drop-to-group', { product_id, group_id });
    return response;
};

export const dropToUngroupedApi = async (group_detail_id) => {
    const response = await postRequest('product/drop-to-ungrouped', { group_detail_id });
    return response;
};

export const deleteSubPin = async (subPinId) => {
    const response = await deleteRequest(`group-product/${subPinId}`);
    return response;
};

export const normalizeProductData = (data = {}) => {
    
    const specifications      = safeJsonParse(data.specifications, []);
    const specificationsArray = ensureArray(specifications);
    const tags                = safeJsonParse(data.tags, []);
    const positions           = safeJsonParse(data.positions, null);
    
    const websiteParsed = safeJsonParse(data.website, []);
    const websiteArray  = ensureArray(websiteParsed);
    const websiteLinks  = websiteParsed ? convertToObject(websiteArray) : [];
    
    const imageUrlArray = data.image_path
    ? data.image_path.map((item) => image_url + item)
    : [];
    
    const uniqueImages = [...new Set(imageUrlArray)];
    
    let prefillData = {
        ...data,
        tags,
        position: positions, 
    };
    
    if (data?.name) {
        prefillData.product_name = data.name;
    }
    
    
    return {
        prefillData, 
        websiteLinks, 
        uniqueImages,
        specificationsArray
    };
};

export const fetchProductById = async (decodedSubid, isSubPin) => {
  const endpoint = isSubPin ? `group-product/${decodedSubid}` : `product/${decodedSubid}`;
  const response = await getRequest(endpoint);
  return response.data ?? {};
};